import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellRing, BellOff, Bell, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export function SaveSearchButton({ search, onSaved, testid = "jobs-save-search-btn", label = "Alert me about new jobs like these" }) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (user && user.role !== "provider") return null;
  if (!user) return <Link to={`/login?next=${encodeURIComponent(window.location.pathname + window.location.search)}`} className="btn-ghost btn-sm" data-testid="jobs-save-search-login"><Bell size={14} />Log in to get job alerts</Link>;
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.post("/job-alerts", search); toast.success(`Alert saved: ${data.name}`); onSaved(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return <button disabled={busy} onClick={save} className="btn-navy btn-sm" data-testid={testid}><BellRing size={14} />{label}</button>;
}

export function MyJobAlerts({ version }) {
  const { user } = useAuth();
  const [list, setList] = useState(null);
  const load = () => api.get("/job-alerts").then((r) => setList(r.data)).catch(() => setList([]));
  useEffect(() => { if (user?.role === "provider") load(); }, [user, version]); // eslint-disable-line
  if (user?.role !== "provider" || !list?.length) return null;
  const toggle = async (a) => { try { await api.patch(`/job-alerts/${a.id}`, { active: !a.active }); load(); } catch (e) { toast.error(errMsg(e)); } };
  const del = async (a) => { try { await api.delete(`/job-alerts/${a.id}`); toast.success("Alert deleted"); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <details className="card p-4 mt-3" data-testid="my-job-alerts">
      <summary className="cursor-pointer text-sm font-semibold flex items-center gap-2"><BellRing size={15} className="text-[#FF8166]" />My job alerts ({list.length}) <span className="font-normal muted">· instant alerts by app, push and email</span></summary>
      <ul className="mt-3 divide-y divide-slate-100">{list.map((a) => (
        <li key={a.id} className="py-2 flex flex-wrap items-center gap-2 text-sm" data-testid={`job-alert-${a.id}`}>
          <span className={`flex-1 min-w-[200px] ${a.active ? "" : "line-through text-slate-400"}`}>{a.name}{a.budget && ` · ${a.budget}`}</span>
          <span className="text-xs muted">{a.sent_count} sent</span>
          <button onClick={() => toggle(a)} className="btn-ghost btn-sm" data-testid={`job-alert-toggle-${a.id}`}>{a.active ? <><BellOff size={13} />Pause</> : <><Bell size={13} />Resume</>}</button>
          <button onClick={() => del(a)} className="btn-ghost btn-sm text-rose-600" aria-label="Delete alert" data-testid={`job-alert-delete-${a.id}`}><Trash2 size={13} /></button>
        </li>))}</ul>
    </details>
  );
}
